export default __webpack_public_path__ + "static/media/Curramore.52d76d74.jpg";